import { motion } from "framer-motion";
import { CheckCircle2Icon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
const badges = ["Descarga inmediata", "Pago único", "Acceso de por vida", "Garantía de 7 días"];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-[#0f2547] py-16 text-white sm:py-24" data-id="element-86" data-mp="15d3zy7ivqsnv">
      <div className="pointer-events-none absolute inset-0" data-id="element-87" data-mp="1jcd4ub1my0cj">
        <div className="absolute left-1/2 top-1/2 h-96 w-96 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#2196f3]/15 blur-[120px]" data-id="element-88" data-mp="1jase6wifz1jy" />
      </div>
      <div className="relative mx-auto max-w-lg px-5 text-center sm:max-w-2xl" data-id="element-89" data-mp="1t1wsdu0amidq">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} data-id="element-90" data-mp="1o3lffaepbrra">
          <h2 className="font-head text-2xl font-800 leading-tight sm:text-4xl" data-id="element-91" data-mp="1x51o9dpvblte">
            Estás a una decisión de transformar la forma en que planificas tus
            tratamientos con alineadores
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-92" data-mp="s5qmdr484wrk">
            Deja de improvisar, reduce refinamientos y comienza a trabajar con un
            sistema clínico diseñado para ayudarte a tomar mejores decisiones
            desde el diagnóstico hasta la finalización del caso.
          </p>

          <div className="mx-auto mt-8 max-w-md" data-id="element-93" data-mp="162dwkvl6tjff">
            <div className="mb-5 rounded-xl bg-white/5 px-4 py-4 ring-1 ring-white/10" data-id="element-94" data-mp="1b2ruvlwzlf09">
              <p className="mb-3 text-xs font-700 uppercase tracking-wider text-white/50" data-id="element-95" data-mp="1ftqg8zwu13ad">
                La oferta termina en
              </p>
              <Countdown data-id="element-96" data-mp="1ksl4wihhdm2e" />
            </div>

            <CtaButton label="Sí, quiero acceder al Sistema Maestro" data-id="element-97" data-mp="1pszggaiaje56" />

            <div className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5" data-id="element-98" data-mp="1pqmnl2azvjdc">
              {badges.map(b => <span key={b} className="inline-flex items-center gap-1 text-xs font-500 text-white/60" data-id="element-99" data-mp="3qu5lvwnyz3jt">
                  <CheckCircle2Icon className="h-3.5 w-3.5 text-[#2196f3]" data-id="element-100" data-mp="3lthqkyspk0js" />
                  {b}
                </span>)}
            </div>
          </div>
        </motion.div>
      </div>

      <footer className="relative mt-14 border-t border-white/10 pt-8 text-center" data-id="element-101" data-mp="3uufttevbo41b">
        <p className="text-xs text-white/40" data-id="element-102" data-mp="ddy0g8nc2y8y">
          © {new Date().getFullYear()} Dra. Karito — Sistema Maestro de
          Planificación con Alineadores™. Todos los derechos reservados.
        </p>
      </footer>
    </section>;
}